import { useDeleteBankAccount } from '@/apis/bank-accounts/hooks/useDeleteBankAccount'
import { useGetBankAccount } from '@/apis/bank-accounts/hooks/useGetBankAccount'
import { useAppAlert } from '@/app/AppAlertProvider'
import { Button } from '@/app/common/components/Button'
import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import { CloseIcon } from '@/app/common/icons/general'
import { AppRoutePaths } from '@/routing/route_paths'
import { BankAccountSchema } from '@/schemas/bank-account.schema'
import { Label } from '@/shad/ui/label'
import { createNewAccount } from '@/storage/applications/reimubrusementAccountSlice'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

export const ReimbursementAccountsPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { fireAlert } = useAppAlert()

  const bankAccount = useGetBankAccount()
  const deleteBankAccountMutation = useDeleteBankAccount()
  const programSettings = useSelector(selectProgramSettings)

  useEffect(() => {
    if (programSettings.reimbursement_module == 0) 
      navigate(-1)
  },[navigate]);

  const handleLinkAccount = () => {
    dispatch(createNewAccount())
    navigate(AppRoutePaths.reimbursements.accounts.link.address)
  }

  function maskLast4Digits(str: string) {
    if (str.length < 4) {
      return str.replace(/./g, '*')
    }

    return str.slice(0, -4) + '****'
  }

  return (
    <PageLoader query={bankAccount}>
      {(account) => {
        const bankAccount = BankAccountSchema.safeParse(account)

        if (!bankAccount.success) {
          return (
            <Card className=" mb-4 mt-2 max-w-lg mx-auto">
              <CardHeader>
                <h2 className="text-lg font-medium">Link your bank account</h2>
              </CardHeader>
              <CardContent>
                <p className="text-sm">
                  Please link your bank account in order to receive
                  reimbursements.
                </p>
                <Button onClick={handleLinkAccount} className="mt-6">
                  Link Account
                </Button>
              </CardContent>
            </Card>
          )
        }

        return (
          <div>
            <div className="max-w-md mx-auto mt-10 p-6">
              <div className="mt-10 flex flex-col items-center">
                <Card className="w-full">
                  <CardHeader>
                    <h2 className="text-lg font-medium">
                      Registered bank account
                    </h2>
                  </CardHeader>
                  <CardContent className="w-full">
                    <div className="w-full mb-4 ">
                      <div className="flex-row mb-2">
                        <div className="flex justify-between items-center mb-2">
                          <Label>
                            Nickname:{' '}
                            <span className="font-bold">
                              {bankAccount.data.account_nickname}
                            </span>
                          </Label>
                          <Button
                            variant={'outline'}
                            onClick={() => {
                              fireAlert({
                                message:
                                  'Are you sure you want to delete this account? This action cannot be undone.',
                                titleText: 'Delete Account',
                                variant: 'warning',
                                denyBtn: true,
                                denyBtnText: 'Cancel',
                                confirmBtn: true,
                                confirmBtnText: 'Delete Account',
                              }).then((response) => {
                                if (response.confirmed) {
                                  deleteBankAccountMutation.mutate()
                                }
                              })
                            }}
                          >
                            Delete
                            <CloseIcon className="ml-2 text-red-500" />
                          </Button>
                        </div>
                        <div className="text-sm text-gray-800">
                          {maskLast4Digits(bankAccount.data.account_number)}
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        )
      }}
    </PageLoader>
  )
}
